import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import { userSession } from '../services';
import { formatMoney } from '../utils/utils';

function CheckinSuccessPage({ onNavigate }) {
  const [orderData, setOrderData] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Get session data first
    const session = userSession.getSession();
    console.log('CheckinSuccessPage - session:', session);
    
    if (session) {
      // Save user info and order data to component state first
      setUserInfo({
        name: session.name,
        phone: session.phone,
        checkinTime: session.checkinTime
      });
      
      // Use finalOrder instead of pendingOrder
      if (session.finalOrder) {
        setOrderData(session.finalOrder);
      }
      
      // Only clear cart and order data, keep user info
      setTimeout(() => {
        userSession.updateSession({ 
          cart: [],
          finalOrder: null,
          pendingOrder: null
          // Keep name, phone, checkinTime for next shopping session
        });
        console.log('Cart and order data cleared, user info preserved');
      }, 100);
      
    } else {
      // Only redirect if there's no session AND no data was loaded
      console.log('No session found, redirecting to checkin');
      onNavigate('/checkin');
      return;
    }
    
    setLoading(false);
  }, [onNavigate]);

  const handleContinueShopping = () => {
    // User info is preserved, can go directly to order page
    onNavigate('/order');
  };

  const handleGoHome = () => {
    onNavigate('/');
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div>Đang xử lý...</div>
      </div>
    );
  }

  if (!userInfo) {
    return (
      <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div>Không tìm thấy thông tin check-in</div>
        <button onClick={() => onNavigate('/checkin')} style={{ marginTop: 16, padding: '8px 16px', background: '#5b6754', color: '#fff', border: 'none', borderRadius: 20 }}>
          Check-in lại
        </button>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <div style={{ background: '#fff', width: 340, minHeight: 600, borderRadius: 8, padding: 32, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <Header onCartClick={() => { onNavigate('/'); }} onMenuClick={() => { onNavigate('/') }} />
        
        <div style={{ marginTop: 40, marginBottom: 40 }}>
          {/* Success Icon */}
          <div style={{ 
            width: 80, 
            height: 80, 
            borderRadius: '50%', 
            background: '#4CAF50', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            margin: '0 auto 24px'
          }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20,6 9,17 4,12"></polyline>
            </svg>
          </div>
          
          <h2 style={{ color: '#5b6754', marginBottom: 16, fontSize: 24, fontWeight: 600 }}>
            Check-in thành công!
          </h2>
          
          <p style={{ color: '#666', fontSize: 16, marginBottom: 8 }}>
            Xin chào <strong>{userInfo.name}</strong>
          </p>
          
          <p style={{ color: '#666', fontSize: 14, marginBottom: 24 }}>
            Thời gian: {new Date().toLocaleString('vi-VN')}
          </p>

          {/* Order Summary */}
          {orderData && (
            <div style={{
              background: '#f8f8f8',
              borderRadius: 12,
              padding: 20,
              marginBottom: 24,
              textAlign: 'left'
            }}>
              <h3 style={{ fontSize: 18, fontWeight: 600, marginBottom: 12, textAlign: 'center' }}>
                Đơn hàng của bạn
              </h3>
              <div style={{ fontSize: 14, color: '#666', marginBottom: 8 }}>
                Số lượng: {orderData.totalItems} sản phẩm
              </div>
              <div style={{ fontSize: 16, fontWeight: 600, color: '#5b6754', marginBottom: 5 }}>
                Tổng tiền tạm tính: {formatMoney(orderData.finalTotal)}đ
              </div>
              <span style={{fontSize: 12, color: '#666', fontStyle: 'italic'}}>(Đây là số tiền tạm tính dựa trên gói giờ bạn đã chọn. Số tiền thực tế có thể bao gồm phụ phí thêm giờ và sẽ được tính khi bạn check-out.)</span>
            </div>
          )}
        </div>
        
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 12 }}>
          
          
          <button 
            style={{
              width: '100%',
              height: 44,
              background: 'transparent',
              color: '#5b6754',
              border: '2px solid #5b6754',
              borderRadius: 24,
              fontSize: 16,
              fontWeight: 500,
              cursor: 'pointer',
              fontFamily: 'NeueEinstellung',
            }}
            onClick={handleGoHome}
          >
            Về trang chủ
          </button>
        </div>
      </div>
    </div>
  );
}

export default CheckinSuccessPage; 